/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import InformationButton from "../../../components/molecules/InformationButton"
import { TENANTS } from "../../../constants"

/* Utils */
import { loc } from "../../../core/utils"
import Date from "../../../form/Date"
import TextField from "../../../form/TextField"
import Bloc from "./Bloc"

/* Forms controls & validation */
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function CompanyBloc(props) {
  const { tunnelData, blocFields, completedFields } = props
  const { clientPageConfiguration, tenant } = tunnelData
  const { company } = clientPageConfiguration

  const getBlocTitleByTenant = () => {
    if (tenant === TENANTS.BPLS) return "firm_bloc_title"
    return "Company"
  }

  return (
    <Bloc
      hide={!company}
      name={getBlocTitleByTenant()}
      completedFields={completedFields}
      totalFieldsNumber={blocFields.length}
    >
      <div className="hard-shadow-white-block">
        <Row>
          <Col lg={12}>
            <TextField
              hidden={false}
              name="company.name"
              label={loc`Company name`}
              trimOnBlur={true}
              disabled={
                tunnelData.data.order.simplifiedJourneyEnabled &&
                !tunnelData?.simplifiedJourneyInputConfiguration?.company?.name.editable
              }
            />
          </Col>
          <Col>
            <TextField
              hidden={false}
              name="company.siret"
              label={loc`Company siret`}
              trimOnBlur={true}
              disabled={
                tunnelData.data.order.simplifiedJourneyEnabled &&
                !tunnelData?.simplifiedJourneyInputConfiguration?.company?.siret.editable
              }
            >
              <InformationButton overlayText={loc("Company siret infos")} />
            </TextField>
          </Col>
          <Col>
            <Date
              hidden={false}
              name="company.executiveBirthdate"
              label={loc`Executive birthdate`}
              trimOnBlur={true}
              format={"DD/MM/YYYY"}
            >
              <InformationButton overlayText={loc("Executive birthdate infos")} />
            </Date>
          </Col>
        </Row>
      </div>
    </Bloc>
  )
}
